import { Suspense } from "react";
import { Form, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { Await, useLoaderData } from "react-router-dom";

export default function HybridHitlistPicker({ formData, setFormData, name, filterFunction = () => true, disabled, loadOnChange }) {
    const { hitlists } = useLoaderData();

    async function handleChange(value) {
        let formDataCopy = { ...formData, hitlist: value };
        if (loadOnChange && value.length) {
            const savedFormData = await loadOnChange(value[0].hybrid_hitlist_id);
            if (savedFormData) {
                formDataCopy = { ...formData, ...savedFormData, hitlist: value };
            }
        }
        setFormData(formDataCopy);
    }

    return (
        <Suspense fallback={<Fallback name={name} />}>
            <Await resolve={hitlists}>
                {resolvedHitlists => (
                    <Form.Group as={Col} className="col-12 col-xl-3 min-w-station">
                        <Form.Label>Hitlist</Form.Label>
                        <Typeahead
                            id={`${name}-hitlist-selection`}
                            options={resolvedHitlists.data.filter(filterFunction)}
                            labelKey={"name"}
                            highlightOnlyResult
                            placeholder="Select hitlist..."
                            clearButton={true}
                            onChange={handleChange}
                            selected={formData.hitlist}
                            disabled={disabled || false}
                        />
                    </Form.Group>
                )}
            </Await>
        </Suspense>
    );
}

function Fallback({ name }) {
    return (
        <Form.Group as={Col} className="col-12 col-xl-3 min-w-station">
            <Form.Label>Hitlist</Form.Label>
            <Typeahead id={`${name}-hitlist-selection-fallback`} options={[]} placeholder="Loading hitlists..." disabled />
        </Form.Group>
    );
}
